import settings from '@/settings'

let get = (headers, data) => {
  let url = `${settings.apetrusApi}/pedidos/`
  if (data) {
    Object.keys(data).forEach((item) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${item}=${
        data[item]
      }`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  get
}
